import React from "react";
import "./PhoneInput.css";

export default function PhoneInput(props) {
  const handlePhoneNumberChange = (event) => {
    props.onNumberChange(event);
  };

  const handlePhoneNumberKeyUp = (event) => {
    props.onNumberKeyUp(event);
  };

  const handleKeyPress = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    const numericRegex = /^[0-9\b]+$/;

    if (!numericRegex.test(keyValue)) {
      event.preventDefault();
    }
  };

  return (
    <div className="phoneInputWrapper centeredFlex">
      <input
        type="tel"
        name="telephone"
        className="phoneInput"
        pattern="[0-9]{2} [0-9]{3} [0-9]{4}"
        maxLength={11}
        minLength={0}
        placeholder="12 456 0789"
        value={props.loginPhoneNumber}
        onChange={(e) => handlePhoneNumberChange(e)}
        onKeyUp={(e) => handlePhoneNumberKeyUp(e)}
        onKeyPress={handleKeyPress}
        style={
          props.sendVerificationCode && props.loginPhoneNumber.length !== 11
            ? { outline: "2px solid var(--pink)" }
            : props.loginPhoneNumber.length === 11
            ? { outline: "2px solid blue" }
            : {}
        }
      />
      <span className="prefix">09</span>
    </div>
  );
}
